export default __webpack_public_path__ + "static/media/2412258.2361bca3.webp";